import { AxiosUtil } from '../utils/axios-util'
import EventConstants from '../constants/EventConstants'
import { Feedback } from '../models/feedback/Feedback'
import { removeNonAsciiChars } from '../utils/DataTransformationUtil'
import {
  errorResponseNotification,
  successNotification,
} from './notification-service'
import { AxiosPromise } from 'axios'

export const getFeedback = (bpId, unreadOnly, skip, limit, eventId) => {
  let url =
    EventConstants.ALL_FEEDBACK +
    '?skip=' +
    skip +
    '&limit=' +
    limit +
    '&unreadOnly=' +
    unreadOnly
  if (eventId) {
    url += '&eventObjectId=' + eventId
  }
  if (bpId) {
    url += '&bpId=' + bpId
  }
  return AxiosUtil.get(url).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const getFeedbackConversation = ({
  vendorObjectId,
  itemBpId,
  parentItemBpId,
  userType,
}) => {
  const feedbackPromises: AxiosPromise<Feedback[]>[] = []
  if (itemBpId === 0 || itemBpId === '0') {
    //it can be '0' or 0
    //general feedback
    const generalFeedbackRequest =
      EventConstants.COMMON +
      'event/vendor/' +
      vendorObjectId +
      '/feedback?userType=' +
      userType

    feedbackPromises.push(AxiosUtil.get(generalFeedbackRequest))
  } else {
    //product feedback
    const productFeedbackRequest =
      EventConstants.COMMON +
      'event/vendor/product/' +
      itemBpId +
      '/feedback?userType=' +
      userType +
      '&bidObjectId=' +
      vendorObjectId

    feedbackPromises.push(AxiosUtil.get(productFeedbackRequest))

    if (parentItemBpId) {
      const productFeedbackRequest =
        EventConstants.COMMON +
        'event/vendor/product/' +
        parentItemBpId +
        '/feedback?userType=' +
        userType +
        '&bidObjectId=' +
        vendorObjectId

      feedbackPromises.push(AxiosUtil.get(productFeedbackRequest))
    }
  }
  return Promise.all(feedbackPromises)
    .then(allResponses => {
      const childItemBpFeedback = allResponses[0].data
      if (allResponses.length > 1) {
        const parentItemBpFeedback = allResponses[1].data
        childItemBpFeedback.unshift(...parentItemBpFeedback)
      }

      return { data: childItemBpFeedback }
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export interface SaveFeedbackProps {
  feedbackMessage: string
  vendorObjectId: string | null
  eventObjectId: string
  itemBpId: string | null
  userType: string | null
  bpName: string | null
  bpId: number | null
  eventName: string | null
  eventId: string | null
  fileId: string | null
}

export const saveFeedback = ({
  feedbackMessage,
  vendorObjectId,
  eventObjectId,
  itemBpId,
  userType,
  bpName,
  bpId,
  eventName,
  eventId,
  fileId,
}: SaveFeedbackProps) => {
  let feedback
  if ((itemBpId ?? '0') !== '0') {
    feedback = {
      vendorObjectId: vendorObjectId,
      type: 'Product',
      comments: feedbackMessage,
      itemBpId: itemBpId,
      userType: userType,
      bpName: bpName,
      bpId: bpId,
      eventName: eventName,
      eventId: eventId,
      fileId,
    }
  } else {
    feedback = {
      vendorObjectId: vendorObjectId,
      eventObjectId: eventObjectId,
      type: 'Vendor',
      comments: feedbackMessage,
      userType: userType,
      bpName: bpName,
      bpId: bpId,
      eventName: eventName,
      eventId: eventId,
      fileId,
    }
  }
  const encodeFeedback = btoa(removeNonAsciiChars(JSON.stringify(feedback)))
  return AxiosUtil.post(
    EventConstants.COMMON + 'event/vendor/product/feedback?vendorId=' + bpId,
    encodeFeedback,
    {
      headers: { 'Content-Type': 'text/plain' },
    },
  )
    .then(res => {
      successNotification([res.data.message])
      return res
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const saveBroadcastFeedback = ({
  feedbackMessage,
  vendorObjectIdArray,
  eventObjectId,
  userType,
  bpName,
  bpId,
  eventName,
}) => {
  const feedback = {
    bidObjectIds: vendorObjectIdArray,
    eventObjectId: eventObjectId,
    type: 'Vendor',
    comments: feedbackMessage,
    userType: userType,
    bpName: bpName,
    bpId: bpId,
    eventName: eventName,
    eventId: eventObjectId,
  }

  const encodeFeedback = btoa(removeNonAsciiChars(JSON.stringify(feedback)))
  return AxiosUtil.post(
    EventConstants.COMMON + 'event/feedback?eventObjectId=' + eventObjectId,
    encodeFeedback,
    {
      headers: { 'Content-Type': 'text/plain' },
    },
  )
    .then(res => {
      successNotification([res.data.message])
      return res
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const getFeedbackHighlight = (eventId, bidObjectId, userType) => {
  return AxiosUtil.get(
    'common/events/v1/vendor/feedback/highlight?bidObjectId=' +
      bidObjectId +
      '&userType=' +
      userType +
      '&eventId=' +
      eventId,
  ).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}
